import { render, staticRenderFns } from "./CompareShare.vue?vue&type=template&id=2868ec90&"
import script from "./CompareShare.vue?vue&type=script&lang=js&"
export * from "./CompareShare.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports